import React from "react";
import { Truck, ShieldCheck, RotateCcw } from "lucide-react";

const items = [
  [Truck, "Free Shipping Across India"],
  [ShieldCheck, "1 Year Warranty"],
  [RotateCcw, "Easy 7-Day Returns"],
];

export const AnnouncementBar = () => (
  <div className="bg-black text-white text-[10px] md:text-[11px] tracking-[0.22em] uppercase" data-testid="announcement-bar">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-2.5 flex items-center justify-center gap-4 md:gap-10 overflow-x-auto no-scrollbar">
      {items.map(([Icon, t], i) => (
        <React.Fragment key={t}>
          <span className="inline-flex items-center gap-2 md:gap-3 shrink-0 text-white/90">
            <Icon size={15} strokeWidth={1.3} className="text-gold" /> {t}
          </span>
          {i < items.length - 1 && <span className="hidden md:inline-block w-px h-4 bg-white/20 shrink-0" />}
        </React.Fragment>
      ))}
    </div>
  </div>
);
